import { compose, withHandlers } from 'recompose'
import { LuckyNumberInput } from 'common-components'

const Component = (props) => <LuckyNumberInput {...props} />
export default (hoc) =>
  compose(
    withHandlers({
      onChange: ({ setValue }) => (value) => {
        setValue(value)
      },
    }),
    hoc
  )(Component)
